import { useIntl } from 'react-intl';

import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import { commonMessages } from '@/messages/common';
import { useConfigProvider } from '@/providers/ConfigProvider';

import * as S from '../ProductDetail.styles';

interface AffirmSentenceProps {
  [key: string]: unknown;
  amount: number;
  variantCTA?: OrderAppCtaType;
}

export const AffirmSentence = ({
  amount,
  variantCTA,
  ...props
}: AffirmSentenceProps) => {
  const { formatMessage } = useIntl();
  const { affirmPaymentMax } = useConfigProvider();

  if (!variantCTA || !['PRE_ORDER', 'ORDER']?.includes(variantCTA)) return null;

  if (variantCTA === 'PRE_ORDER') {
    return (
      <S.AffirmSentence data-testid='AffirmSentencePreOrder'>
        {formatMessage(commonMessages.preorderAffirm)}
      </S.AffirmSentence>
    );
  }

  const isAffirmPriceValid =
    affirmPaymentMax && amount <= affirmPaymentMax * 100;

  if (affirmPaymentMax && !isAffirmPriceValid) {
    return (
      <S.AffirmSentence data-testid='AffirmSentenceInvalidAmount'>
        {formatMessage(commonMessages.invalidAffirmAmount)}
      </S.AffirmSentence>
    );
  }

  return variantCTA === 'ORDER' && isAffirmPriceValid ? (
    <S.AffirmSentence
      data-amount={amount}
      data-testid='AffirmSentence'
      {...props}
    />
  ) : null;
};
